import React from 'react';
import MemberTemp from '../components/MemberTemp';
import MemberForm from '../components/MemberForm';
const Login = () => {
    return (
        <MemberTemp>
             <MemberForm type="login"/>
         </MemberTemp>
    );
};

export default Login;